import React, { useEffect, useRef } from "react";
import "./UniRatesMotion.scss";

import down from "../../assets/icons/down.svg";
import up from "../../assets/icons/up.svg";
import arrow from "../../assets/icons/Arrow_left.svg";
import { getFlagUrl } from "../../utils/getFlagUrl";

const translations = {
  USD: "دلار",
  EUR: "یورو",
  GBP: "پوند",
  AED: "درهم",
  TRY: "لیر",
  CAD: "دلار کانادا",
};

const getCurrencyNameInPersian = (name) => translations[name] || name;

const UniRatesMotion = ({ uniPrices }) => {
  const tickerRef = useRef();
  

  useEffect(() => {
    // Duplicate content dynamically for seamless scrolling
    const tickerContent = tickerRef.current;
    const originalContent = tickerContent.innerHTML;
    tickerContent.innerHTML += originalContent; // Duplicate the items

    // console.log(tickerContent);
    
  }, []);

  return (
    <div className="uni-rates-motion-container">
      <div className="ticker-content" ref={tickerRef}>
        {uniPrices.map((c, index) => (
          <div className="ticker-item" key={index}>
            <div className="flex items-center justify-start text-center align-middle whitespace-nowrap">
              <div className="currency-flag flex">
                <img
                  src={getFlagUrl(c.name)}
                  alt={c.name}
                />
                <img
                  src={arrow}
                  alt="arrow"
                  className="max-[580px]:!w-[1.5rem]"
                />
                <img
                  src={getFlagUrl(c.base)}
                  alt={c.base}
                />
              </div>
              <div className="currency-name mr-[0.5rem]">
                {getCurrencyNameInPersian(c.name)} \{" "}
                {getCurrencyNameInPersian(c.base)}
              </div>
            </div>
            <div className="text-center align-middle whitespace-nowrap">
              <div
                className={`mr-[1rem] flex justify-center items-center price-value ${
                  c.price === c.prePrice
                    ? ""
                    : c.price >= c.prePrice
                    ? "green"
                    : "red"
                }`}
              >
                {c.price.toLocaleString()}
                <div className="price-icon">
                  {c.price === c.prePrice ? (
                    "---"
                  ) : (
                    <img
                      className="max-[580px]:w-[1.5rem]"
                      src={c.price >= c.prePrice ? up : down}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {uniPrices.map((c, index) => (
          <div className="ticker-item" key={index}>
            <div className="flex items-center justify-start text-center align-middle whitespace-nowrap">
              <div className="currency-flag flex">
                <img
                  src={getFlagUrl(c.name)}
                  alt={c.name}
                />
                <img
                  src={arrow}
                  alt="arrow"
                  className="max-[580px]:!w-[1.5rem]"
                />
                <img
                  src={getFlagUrl(c.base)}
                  alt={c.base}
                />
              </div>
              <div className="currency-name mr-[0.5rem]">
                {getCurrencyNameInPersian(c.name)} \{" "}
                {getCurrencyNameInPersian(c.base)}
              </div>
            </div>
            <div className="text-center align-middle whitespace-nowrap">
              <div
                className={`mr-[1rem] flex justify-center items-center price-value ${
                  c.price === c.prePrice
                    ? ""
                    : c.price >= c.prePrice
                    ? "green"
                    : "red"
                }`}
              >
                {c.price.toLocaleString()}
                <div className="price-icon">
                  {c.price === c.prePrice ? (
                    "---"
                  ) : (
                    <img
                      className="max-[580px]:w-[1.5rem]"
                      src={c.price >= c.prePrice ? up : down}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {uniPrices.map((c, index) => (
          <div className="ticker-item" key={index}>
            <div className="flex items-center justify-start text-center align-middle whitespace-nowrap">
              <div className="currency-flag flex">
                <img
                  src={getFlagUrl(c.name)}
                  alt={c.name}
                />
                <img
                  src={arrow}
                  alt="arrow"
                  className="max-[580px]:!w-[1.5rem]"
                />
                <img
                  src={getFlagUrl(c.base)}
                  alt={c.base}
                />
              </div>
              <div className="currency-name mr-[0.5rem]">
                {getCurrencyNameInPersian(c.name)} \{" "}
                {getCurrencyNameInPersian(c.base)}
              </div>
            </div>
            <div className="text-center align-middle whitespace-nowrap">
              <div
                className={`mr-[1rem] flex justify-center items-center price-value ${
                  c.price === c.prePrice
                    ? ""
                    : c.price >= c.prePrice
                    ? "green"
                    : "red"
                }`}
              >
                {c.price.toLocaleString()}
                <div className="price-icon">
                  {c.price === c.prePrice ? (
                    "---"
                  ) : (
                    <img
                      className="max-[580px]:w-[1.5rem]"
                      src={c.price >= c.prePrice ? up : down}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
        {uniPrices.map((c, index) => (
          <div className="ticker-item" key={index}>
            <div className="flex items-center justify-start text-center align-middle whitespace-nowrap">
              <div className="currency-flag flex">
                <img
                  src={getFlagUrl(c.name)}
                  alt={c.name}
                />
                <img
                  src={arrow}
                  alt="arrow"
                  className="max-[580px]:!w-[1.5rem]"
                />
                <img
                  src={getFlagUrl(c.base)}
                  alt={c.base}
                />
              </div>
              <div className="currency-name mr-[0.5rem]">
                {getCurrencyNameInPersian(c.name)} \{" "}
                {getCurrencyNameInPersian(c.base)}
              </div>
            </div>
            <div className="text-center align-middle whitespace-nowrap">
              <div
                className={`mr-[1rem] flex justify-center items-center price-value ${
                  c.price === c.prePrice
                    ? ""
                    : c.price >= c.prePrice
                    ? "green"
                    : "red"
                }`}
              >
                {c.price.toLocaleString()}
                <div className="price-icon">
                  {c.price === c.prePrice ? (
                    "---"
                  ) : (
                    <img
                      className="max-[580px]:w-[1.5rem]"
                      src={c.price >= c.prePrice ? up : down}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UniRatesMotion;
